import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getVat } from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader.js'
import { write, utils } from 'xlsx'
import Toggle from 'react-toggle'
import Select from 'react-select'

class BasicReportTrip extends React.Component {
  state = {
    country_list: [],
    typeTagList: [],
    Data: [],
    reportUrl: '',
    isSearching: false,

    // filters
    bookingStatus: '',
    country: '',
    tripId: null,

    tripList: [],

    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    booking_start_from: null,
    booking_start_to: null,
    booking_end_from: null,
    booking_end_to: null,
    typeTag: '',

    future_booking_only: false,
    future_bookings_from: '',
  }

  componentDidMount() {
    this.getCountries()
    this.setState({
      typeTagList: Constant.getTypeTags(),
    })
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getTripList = async (country) => {
    this.setState({ tripList: [], tripId: null })
    var that = this
    await axios
      .get(Constant.getAPI() + '/trips/cruise-trips-dropdown', {
        headers: { Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`, country_short_name: country },
        params: {
          country: country,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            tripList: res?.data?.data?.map((itm) => ({
              label: `${itm.name_en}/${itm.name_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getBookings = async () => {
    this.setState({ isSearching: true })

    var dateDMY1 = moment(this.state.start_date).format('MM/DD/YYYY')
    var dateDMY2 = moment(this.state.end_date).format('MM/DD/YYYY')
    var dateDMY3 = moment(this.state.booking_start_from).format('MM/DD/YYYY')
    var dateDMY4 = moment(this.state.booking_start_to).format('MM/DD/YYYY')
    var dateDMY5 = moment(this.state.booking_end_from).format('MM/DD/YYYY')
    var dateDMY6 = moment(this.state.booking_end_to).format('MM/DD/YYYY')

    let data = {
      bookingStatus: this.state.bookingStatus ? this.state.bookingStatus : null,
      country: this.state.country,
      typeTag: this.state.typeTag,
    }

    if (dateDMY1 && dateDMY1 != 'Invalid date') data.bookingDateFrom = dateDMY1
    if (dateDMY2 && dateDMY2 != 'Invalid date') data.bookingDateTo = dateDMY2
    if (dateDMY3 && dateDMY3 != 'Invalid date') data.booking_start_from = dateDMY3
    if (dateDMY4 && dateDMY4 != 'Invalid date') data.booking_start_to = dateDMY4
    if (dateDMY5 && dateDMY5 != 'Invalid date') data.booking_end_from = dateDMY5
    if (dateDMY6 && dateDMY6 != 'Invalid date') data.booking_end_to = dateDMY6
    if (this.state.tripId) data.tripId = this.state.tripId?.value || ''

    data.future_booking_only = this.state.future_booking_only
    data.future_bookings_from = this.state.future_bookings_from

    await axios
      .post(Constant.getAPI() + `/reports/cruise-trip-report`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((response) => {
        this.setState({
          Data: response?.data?.data,
        })
      })
      .catch((err) => {
        Swal.fire({
          title: err?.response?.data?.message || err?.response?.data?.data,
          icon: 'error',
          text: err?.response?.data?.data?.details[0]?.message,
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  checkDateDifference(date1, date2) {
    // Parse the dates using Moment.js
    const momentDate1 = moment(date1, 'YYYY-MM-DD')
    const momentDate2 = moment(date2, 'YYYY-MM-DD')

    // Calculate the difference in months
    const diffMonths = momentDate2.diff(momentDate1, 'months')
    // Compare the difference with 6
    if (diffMonths > 6) {
      return true
    } else {
      return false
    }
  }

  handleChange = (event) => {
    event.persist()

    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        if (
          (event?.target?.name == 'start_date' || event?.target?.name == 'end_date') &&
          this.checkDateDifference(this.state.start_date, this.state.end_date)
        ) {
          if (event?.target?.name == 'start_date') {
            this.setState({
              end_date: moment(this.state.start_date, 'YYYY-MM-DD').add(6, 'months').format('YYYY-MM-DD'),
            })
          } else {
            this.setState({
              start_date: moment(this.state.end_date, 'YYYY-MM-DD').subtract(6, 'months').format('YYYY-MM-DD'),
            })
          }
        }
      }
    )

    if (event?.target?.name == 'country') {
      this.setState({ tripList: [], tripId: null })
      if (event.target.value != '') {
        this.getTripList(event.target.value)
      }
    }
  }

  searchData = async () => {
    this.setState({
      Data: [],
    })
    this.getBookings()
  }

  toggleFutureBookingOnly = (event) => {
    this.setState({
      future_booking_only: event.target.checked,
      start_date:
        event.target.checked == true
          ? moment().subtract(2, 'years').format('YYYY-MM-DD')
          : moment().subtract(1, 'months').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      booking_start_from: null,
      booking_start_to: null,
      booking_end_from: null,
      booking_end_to: null,
      future_bookings_from: event.target.checked == true ? moment().format('YYYY-MM-DD') : '',
    })
  }

  clearSearch = async () => {
    this.setState({
      bookingStatus: '',
      country: '',
      tripId: null,
      typeTag: '',

      start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),

      booking_start_from: '',
      booking_start_to: '',
      booking_end_from: '',
      booking_end_to: '',

      Data: [],

      future_booking_only: false,
      future_bookings_from: '',
    })
  }

  handleClear = () => {
    this.setState({ tripId: null })
  }

  handleTripChange = (event) => {
    this.setState({
      tripId: event,
    })
  }

  render() {
    const columns = [
      {
        name: 'country',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'customer_name',
        label: 'Customer Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'phone',
        label: 'Customer Phone',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'order_number',
        label: 'Booking ID',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'issue_date',
        label: 'Issue Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? <div style={{ textWrap: 'nowrap' }}>{moment(value).format('YYYY-MM-DD')}</div> : '--',
        },
      },
      {
        name: 'start_date',
        label: 'Booking Start Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'end_date',
        label: 'Booking End Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'name_en',
        label: 'Trip Name English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'name_ar',
        label: 'Trip Name Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'departure_location',
        label: 'Departure Location',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'arrival_location',
        label: 'Arrival Location',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'total_amount',
        label: 'Total Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'trip_amount',
        label: 'Trip Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'invoice_reference_id',
        label: 'Order Reference Id',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'payment_method',
        label: 'Payment Method',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'booking_status',
        label: 'Booking Status',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'coupon_code',
        label: 'Coupon',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => value || '--',
        },
      },
      {
        name: 'coupon_applied_amount',
        label: 'Discount Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => value || '--',
        },
      },
      {
        name: 'wallet_amount_applied',
        label: 'Wallet Applied Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => value || '--',
        },
      },
      {
        name: 'vat_amount',
        label: 'Vat',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return value ? value + ` (${getVat(tableMeta.rowData[0])}%)` : '--'
          },
        },
      },
      {
        name: 'passenger_count',
        label: 'Passenger Count',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => value || '--',
        },
      },
      {
        name: 'passenger_names',
        label: 'Passengers',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>
                {value.split(', ').map((itm) => (
                  <>
                    {itm}
                    <br />
                  </>
                ))}
              </div>
            ) : (
              '--'
            ),
        },
      },
      {
        name: 'booking_comments',
        label: 'Comments',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? (
              <div style={{ textWrap: 'nowrap' }}>
                {value.split(', ').map((itm) => (
                  <>
                    {itm}
                    <br />
                  </>
                ))}
              </div>
            ) : (
              '--'
            ),
        },
      },
    ]

    const options = {
      filter: false,
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      downloadOptions: {
        filename: 'Bookings',
      },
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Bookings`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            temp[columns[idx].name] = v
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        // cancel default  CSV download from table
        return false
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? <Loader open={this.state.isSearching} /> : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Basic Report</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Basic Report</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Booking Status</label>
                            <div className="col-sm-9">
                              <select
                                name="bookingStatus"
                                className="form-control"
                                value={this.state.bookingStatus}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                <option value={'Pending'}>Pending</option>
                                <option value={'Successful'}>Successful</option>
                                <option value={'Cancelled'}>Cancelled</option>
                                <option value={'Confirmed'}>Confirmed</option>
                                <option value={'Postponed'}>Postponed</option>
                                <option value={'Incomplete'}>Incomplete</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country</label>
                            <div className="col-sm-9">
                              <select
                                name="country"
                                className="form-control"
                                value={this.state.country}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                {this.state.country_list.map((country) => (
                                  <option
                                    value={country.country_short_name}
                                    key={country.country_short_name}
                                  >
                                    {country.country_name_en + '/' + country.country_name_ar}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Trip Name</label>
                            <div className="col-sm-9">
                              <Select
                                name="tripId"
                                value={this.state.tripId}
                                onChange={this.handleTripChange}
                                options={this.state.tripList}
                                isMulti={false}
                                isSearchable={true}
                                isClearable
                                onClear={this.handleClear}
                                placeholder="Select Options"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Tag Type</label>
                            <div className="col-sm-9">
                              <select
                                name="typeTag"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.typeTag}
                              >
                                <option value={''}>All</option>
                                {this.state?.typeTagList?.length > 0
                                  ? this.state.typeTagList.map((tag) => (
                                    <option
                                      value={tag}
                                      key={tag}
                                    >
                                      {tag}
                                    </option>
                                  ))
                                  : null}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-12"
                          style={{ borderBottom: '1px solid #ddd', marginBottom: 15 }}
                        ></div>
                        <div className="col-4">
                          <div className="form-group row">
                            <label className="col-8 col-form-label">Future bookings Only</label>
                            <div className="col-4">
                              <Toggle
                                className="f-right"
                                checked={this.state.future_booking_only == true ? true : false}
                                onChange={this.toggleFutureBookingOnly}
                              />
                            </div>
                          </div>
                        </div>
                        {this.state.future_booking_only && (
                          <>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Booking From Date</label>
                                <div className="col-sm-9">
                                  <input
                                    type="date"
                                    id="date"
                                    name="future_bookings_from"
                                    className="form-control"
                                    onChange={this.handleChange}
                                    value={this.state.future_bookings_from}
                                    min={moment().format('YYYY-MM-DD')}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {!this.state.future_booking_only && (
                          <>
                            <div
                              className="col-12"
                              style={{ borderBottom: '1px solid #ddd', marginBottom: 15 }}
                            ></div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Created Start Date</label>
                                <div className="col-sm-9">
                                  <input
                                    type="date"
                                    id="date"
                                    name="start_date"
                                    className="form-control"
                                    onChange={this.handleChange}
                                    value={this.state.start_date}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Created End Date</label>
                                <div className="col-sm-9">
                                  <input
                                    type="date"
                                    max={moment().format('YYYY-MM-DD')}
                                    id="date"
                                    name="end_date"
                                    className="form-control"
                                    onChange={this.handleChange}
                                    value={this.state.end_date}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-md-3 col-form-label">Booking start from</label>
                                <div className="col-md-9">
                                  <input
                                    type="date"
                                    id="booking_start_from"
                                    className="form-control"
                                    value={this.state.booking_start_from}
                                    name="booking_start_from"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-md-3 col-form-label">Booking start To</label>
                                <div className="col-md-9">
                                  <input
                                    type="date"
                                    id="booking_start_to"
                                    className="form-control"
                                    value={this.state.booking_start_to}
                                    name="booking_start_to"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-md-3 col-form-label">Booking end from</label>
                                <div className="col-md-9">
                                  <input
                                    type="date"
                                    id="booking_end_from"
                                    className="form-control"
                                    value={this.state.booking_end_from}
                                    name="booking_end_from"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group row">
                                <label className="col-md-3 col-form-label">Booking end To</label>
                                <div className="col-md-9">
                                  <input
                                    type="date"
                                    id="booking_end_to"
                                    className="form-control"
                                    value={this.state.booking_end_to}
                                    name="booking_end_to"
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              className="col-6"
                              style={{ color: 'red' }}
                            >
                              You can get maximum 6 months rocords at a time
                            </div>
                            <div className="text-right col-6">
                              {this.state.isSearching ? (
                                <button
                                  className="btn btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <>
                                  <button
                                    style={{ width: 150 }}
                                    className="btn btn-inverse waves-effect m-r-10"
                                    onClick={this.clearSearch}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    style={{ width: 150 }}
                                    onClick={this.searchData}
                                    className="btn btn-inverse waves-effect"
                                  >
                                    Search
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-12">
                  <div className="card card-border-default">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Trip Report'}
                          className="table-responsive"
                          data={this.state.Data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BasicReportTrip
